<button
  type="button"
  class="flex justify-center items-center"
  [ngClass]="{
    'bg-background-container-primary': type() === 'primary',
    'bg-background-container-secondary': type() === 'secondary',
    'rounded-radius-tertiary': size() === 'small',
  }"
  [disabled]="disabled()"
  (click)="onClick($event)"
>
  <svg-icon [key]="icon()" [size]="size() === 'small' ? '24' : '32'"></svg-icon>
</button>
